// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import React, {useCallback, useContext, useEffect, useMemo,
    useRef} from 'react';
import {Link} from 'react-router-dom';
import cn from 'classnames';
import {use_pathname} from '../../../../hola/pub/lib/use_pathname';
import Icon_chevron_left from '../../../../hola/pub/img/hola2023/icons/16/chevron_left.svg';
import Icon_chevron_right from '../../../../hola/pub/img/hola2023/icons/16/chevron_right.svg';
import {Settings_context} from '../../../../hola/pub/settings_ctx';
// @ts-ignore
import {App_context} from '../../../../hola/pub/context.js';
import styles from './paging.module.less';

interface i_paging_link_props {
    to: string;
    active: boolean;
    text: string;
}
const Paging_link = (props: i_paging_link_props)=>{
    const {theme} = useContext(Settings_context);
    const {to, active, text} = props;
    const cls = cn(styles.link, active && styles.active);
    return <Link to={to} className={cls}>
      <span className={cn(theme.P, theme.p3)}>{text}</span>
    </Link>;
};

interface i_paging_props {
    count: number;
    param: string;
    category?: string;
    short?: boolean;
    on_change?: ()=>void;
}
export const Paging = (props: i_paging_props)=>{
    // @ts-ignore
    const {is_client} = useContext(App_context);
    const {count, param, category, short, on_change} = props;
    const {get_url, params} = use_pathname();
    const cur = params[param] ? +params[param] : 1;
    const prev = useRef<number>(cur);
    const show_prev = cur > 1;
    const show_next = cur < count;
    const show_left_ellipsis = cur >= 4;
    const show_right_ellipsis = cur <= count - 3;
    const page_url = useCallback((n: number)=>{
        return get_url({[param]: `${n}`, category, per_page: params.per_page});
    }, [param, category, params.per_page]);
    useEffect(()=>{
        if (on_change && cur != prev.current)
            on_change();
        prev.current = cur;
    }, [cur]);
    const elements = useMemo(()=>{
        if (!cur || !count)
            return [];
        const res = [];
        const add_pages = (n: number|[number, number], text?: string)=>{
            if (typeof n == 'number')
                return void res.push({page: n, text: `${text || n}`});
            for (let i = n[0]; i <= n[1]; i++)
                res.push({page: i, text: `${text || i}`});
        };
        if (count <= 5)
        {
            add_pages([1, count]);
            return res;
        }
        if (short)
        {
            if (cur <= 2)
                add_pages([1, 4]);
            else if (cur >= count-1)
                add_pages([count-3, count]);
            else
                add_pages([cur-1, cur+2]);
            return res;
        }
        const left_mid = Math.ceil((cur-1)/2);
        const right_mid = cur + Math.ceil((count-cur)/2);
        if (show_left_ellipsis && show_right_ellipsis)
        {
            add_pages(1);
            add_pages(left_mid, '...');
            add_pages([cur-1, cur+1]);
            add_pages(right_mid, '...');
            add_pages(count);
            return res;
        }
        if (!show_left_ellipsis)
        {
            add_pages([1, 4]);
            add_pages(right_mid, '...');
            add_pages(count);
            return res;
        }
        if (!show_right_ellipsis)
        {
            add_pages(1);
            add_pages(left_mid, '...');
            add_pages([count-3, count]);
            return res;
        }
        return res;
    }, [cur, count, show_left_ellipsis, show_right_ellipsis, category]);
    return is_client && <div className={styles.root}>
      <div className={styles.numbers}>
        {show_prev && <Link to={get_url({[param]: `${cur-1}`, category})}
          className={cn(styles.button, styles.prev)}>
          <Icon_chevron_left width={16} height={16}/>
        </Link>}
        {elements.map(({page, text})=><Paging_link key={page} text={text}
          to={page_url(page)} active={cur==page}/>)}
        {show_next && <Link to={get_url({[param]: `${cur+1}`, category})}
          className={cn(styles.button, styles.next)}>
          <Icon_chevron_right width={16} height={16}/>
        </Link>}
      </div>
    </div>;
};
